module.exports = __webpack_public_path__ + "img/hp-case-ice.ec8ce5eb.png";